<form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
  <p class="mb-3">
    Diese Ansicht ist passwortgeschützt. Bitte geben Sie das Passwort ein:
  </p>

  <p-inputOtp formControlName="guestPassword" [mask]="false" />

  @if (
    passwordForm.get('guestPassword')?.invalid &&
    passwordForm.get('guestPassword')?.touched
  ) {
    <small class="p-error">Bitte geben Sie das Passwort ein</small>
  }

  @if (error) {
    <div class="p-error border-round mt-3">
      <i class="fas fa-exclamation-circle mr-2"></i>
      {{ error }}
    </div>
  }
</form>
